import React from 'react';
import { Channel } from './types';
import PreviewPanel from './preview-panel';
import { PreviewConfig } from '../shared/types/config';
import { previewChannelConfig } from './preview-config';

type Props = {
    config: PreviewConfig;
    channel: Channel;
    active?: boolean;
};

function Preview(props: Props) {
    const { config, channel, active } = props;
    if (active) {
        const { finnkode, wwwUrl } = config;
        const pathname = '/distribution-front/external/carousel/preview';
        const search = `?finnkode=${finnkode}&channel=${channel}&variant=control`;
        const url = `${wwwUrl}${pathname}${search}`;

        const {
            height,
            width,
            top,
            left,
            phoneHeight,
            phoneWidth,
            phoneTop,
            phoneLeft,
            iframeBackgroundColor,
            backgroundImageUrl,
            phoneBackgroundImageUrl,
        } = previewChannelConfig(channel, config);

        return (
            <div className="preview-panels" style={{padding:"16px"}}>
                <section className="desktop">
                    <h4 className="u-screen-reader-only">
                        Forhåndsvisning desktop
                    </h4>
                    <PreviewPanel
                        height={height}
                        width={width}
                        backgroundImageUrl={backgroundImageUrl}
                        iframeBackgroundColor={iframeBackgroundColor}
                        backgroundHeight={812}
                        backgroundWidth={1200}
                        url={url}
                        title="Forhåndsvisning desktop"
                        top={top}
                        left={left}
                        ratio="67%"
                        disableLinks
                        verify
                    />
                </section>

                <section className="phone">
                    <h4 className="u-screen-reader-only">
                    </h4>
                    <PreviewPanel
                        height={phoneHeight}
                        width={phoneWidth}
                        backgroundImageUrl={phoneBackgroundImageUrl}
                        iframeBackgroundColor={iframeBackgroundColor}
                        backgroundHeight={812}
                        backgroundWidth={375}
                        url={url}
                        title="Forhåndsvisning mobil"
                        top={phoneTop}
                        left={phoneLeft}
                        ratio="216%"
                        disableLinks
                        verify
                    />
                </section>
            </div>
        );
    }
    return null;
}

export default Preview;
